<template>
<div></div>
</template>

<script>
  export default {
    name: "BaseFooter"
  }
</script>

<style scoped>

</style>
